import React from 'react';
import withIcon from '../utilities/withIcon';

const IconInfo = () => {
  return (
    <g>
      <path d="m8 .05a7.95 7.95 0 1 0 7.95 7.95 7.959 7.959 0 0 0 -7.95-7.95zm-.707 3.1956a.75.75 0 1 1 1.5 0v1.0264a.75.75 0 0 1 -1.5 0zm2.8428 8.7266-1.5626 1.5615a.751.751 0 0 1 -1.28-.53v-4.2464l-.2812.2813a.75.75 0 0 1 -1.0608-1.0606l1.5615-1.5615a.7511.7511 0 0 1 1.28.53v4.2469l.2822-.282a.75.75 0 1 1 1.0605 1.0605z" />
    </g>
  );
};

export default withIcon(IconInfo);
